import { E_RouterNames } from "@/router/types";

export interface IBuildGdsAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId?: number
    sensorId?: string
    createTime?: string
}

export function buildGdsAlarmHistoryRouter(params: IBuildGdsAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.gdsAlarmHistory,
        query: params
    }
}
